import LocalizedStrings from "react-localization";
import LocalText from "src/local";

const localizationStrings = new LocalizedStrings({
  ja: {
    navigationBarSignInTitle:
      LocalText.screens.authSignIn.navigationBarSignInTitle,
    inputEmailPlaceholder: LocalText.screens.authSignIn.inputEmailPlaceholder,
    inputPasswordPlaceholder:
      LocalText.screens.authSignIn.inputPasswordPlaceholder,
    inputEmailValidationRequire:
      LocalText.screens.authSignIn.inputEmailValidationRequire,
    inputEmailValidationFormat:
      LocalText.screens.authSignIn.inputEmailValidationFormat,
    inputPasswordValidationRequire:
      LocalText.screens.authSignIn.inputPasswordValidationRequire,
    btnSignIn: LocalText.screens.authSignIn.btnSignIn,
    btnRestore: LocalText.screens.authSignIn.btnRestore,
    navigationBarPasswordResetTitle:
      LocalText.screens.authSignIn.navigationBarPasswordResetTitle,
  },
});

export { localizationStrings };
